import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createLootBoxApi, storeLootBoxApi } from './lootBoxSlice';
import isEmpty from 'lodash/isEmpty';
import { RequestBodyConverter } from '../RequestBodyConverter';
import LootBoxForm from './LootBoxForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { initialValues, pictureAttributeNames } from './initialValue';

function LootBoxCreate() {
    const [resetCount, setResetCount] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.

        dispatch(storeLootBoxApi({ navigate, values }));
    };

    return (
        <LootBoxForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default LootBoxCreate;
